// File: frontend/src/components/upload/UploadProgress.js

import React from 'react';
import { Upload, Loader2, CheckCircle } from 'lucide-react';
import SectionProgress from './SectionProgress';
import styles from './UploadProgress.module.css';

const UploadProgress = ({ state, progress, fileName, currentSection, completedSections, allSections }) => {
  const getStateMessage = () => {
    if (state === 'uploading') {
      return 'Uploading your policy...';
    }
    
    if (state === 'processing' && currentSection) {
      const sectionLabels = {
        'POLICY_METADATA': 'Extracting policy details...',
        'INSURANCE_COMPANY': 'Identifying insurance company...',
        'INSURED_INFORMATION': 'Processing insured information...',
        'VEHICLES': 'Analyzing vehicles...',
        'PROPERTIES': 'Analyzing properties...',
        'DRIVERS': 'Extracting driver information...',
        'COVERAGES': 'Understanding coverages...',
        'ENDORSEMENTS': 'Processing endorsements...',
        'DECLINED_COVERAGES': 'Identifying declined coverages...',
        'PREMIUM_BILLING': 'Calculating premium details...',
        'RATING_INFORMATION': 'Analyzing rating factors...',
        'CLAIMS_HISTORY': 'Reviewing claims history...',
        'AGENT_INFORMATION': 'Extracting agent details...',
        'ADDITIONAL_DETAILS': 'Finalizing extraction...'
      };
      
      return sectionLabels[currentSection] || 'Extracting policy details with AI...';
    }
    
    return 'Processing...';
  };

  const getStateIcon = () => {
    if (state === 'uploading') {
      return <Upload size={48} strokeWidth={2} className={styles.uploadingIcon} />;
    }

    return <Loader2 size={48} strokeWidth={2} className={styles.processingIcon} />;
  };

  return (
    <div className={styles.progressContainer}>
      <div className={styles.iconContainer}>
        {getStateIcon()}
      </div>

      <h3 className={styles.progressTitle}>{getStateMessage()}</h3>

      {fileName && (
        <p className={styles.fileName}>{fileName}</p>
      )}

      <div className={styles.progressBar}>
        <div 
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>

      <p className={styles.progressPercent}>{progress}%</p>

      <div className={styles.progressSteps}>
        <div className={`${styles.step} ${progress >= 20 ? styles.completed : ''}`}>
          <div className={styles.stepIcon}>
            {progress >= 20 ? <CheckCircle size={16} strokeWidth={2} /> : '1'}
          </div>
          <span className={styles.stepLabel}>Upload</span>
        </div>

        <div className={`${styles.step} ${progress >= 25 ? styles.completed : ''}`}>
          <div className={styles.stepIcon}>
            {progress >= 25 ? <CheckCircle size={16} strokeWidth={2} /> : '2'}
          </div>
          <span className={styles.stepLabel}>AI Analysis</span>
        </div>

        <div className={`${styles.step} ${progress >= 100 ? styles.completed : ''}`}>
          <div className={styles.stepIcon}>
            {progress >= 100 ? <CheckCircle size={16} strokeWidth={2} /> : '3'}
          </div>
          <span className={styles.stepLabel}>Complete</span>
        </div>
      </div>

      {state === 'processing' && allSections.length > 0 && (
        <SectionProgress 
          currentSection={currentSection}
          completedSections={completedSections}
          allSections={allSections}
        />
      )}
    </div>
  );
};

export default UploadProgress;